export { default as addExcludedLanguage } from './utils/addExcludedLanguage';
export { default as checkCanTranslate } from './utils/checkCanTranslate';
export { default as initSupportedLanguages } from './utils/initSupportedLanguages';
export { default as initAndGetSupportedLanguageMap } from './utils/initAndGetSupportedLanguageMap';
export { default as getLocaleOfSupportedLanguageMap } from './utils/getLocaleOfSupportedLanguageMap';
export { default as getOgmaSupportedLanguageTag } from './utils/getOgmaSupportedLanguageTag';
export { default as getDetectedLanguage } from './utils/getDetectedLanguage';
export { default as getLanguageNameFromTag } from './utils/getLanguageNameFromTag';
export { default as getUserLanguageName } from './utils/getUserLanguageName';
export { default as getUserLanguageTag } from './utils/getUserLanguageTag';
export { default as getTargetLanguageName } from './utils/getTargetLanguageName';
export { default as getTargetLanguageTag } from './utils/getTargetLanguageTag';
export { default as getTranslationSettings } from './utils/getTranslationSettings';
export { default as getIsUserLocaleSupported } from './utils/getIsUserLocaleSupported';
export { default as translateText } from './services/translateText';
export { default as updateTranslationMode } from './utils/updateTranslationMode';
export { default as updateTranslationSettings } from './utils/updateTranslationSettings';
